import React from "react";
import {
    Create,
    FormTab,
    TextInput,
    TabbedForm,
    Toolbar, maxLength, required
} from 'react-admin';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    descripcion: {display: 'inline-block', width: 400, marginLeft: 8},
    codigo: {display: 'inline-block', width: 200, marginLeft: 8},
}));

const PostCreateToolbar = props => {
    return (
        <Toolbar {...props} >

        </Toolbar>
    )
};

// redirect to the related Author show page
const redirect = (basePath, id, data) => `/RequerimientoConcepto`;

const CompraCptCreate = props => {
    const classes = useStyles();

    const PostTitle = ({record}) => {
        return <span>Alta de Concepto de Requerimiento</span>;
    };

    return (
        <Create title={<PostTitle/>} {...props}>
            <TabbedForm
                // redirect={redirect}
                // toolbar={<PostCreateToolbar />} 
            >
                {/*Datos*/}
                <FormTab label="Requerimiento Concepto">
                    <TextInput label="Req. Concepto" source="requerimiento_concepto"
                               validate={[maxLength(20), required()]}/>
                    <TextInput label="Descripción" source="requerimiento_concepto_d" validate={[maxLength(200)]}/>
                </FormTab>
            </TabbedForm>
        </Create>
    )
};
export default CompraCptCreate;


